import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OpenGraphData } from "../types/api";
import { getOpenGraphData, normalizeUrlForCache } from "../actions/sharedActions";

interface OpenGraphState {
  data: { [url: string]: OpenGraphData | null };
  status: { [url: string]: "idle" | "loading" | "succeeded" | "failed" };
  error: { [url: string]: string | null };
}

const initialState: OpenGraphState = {
  data: {},
  status: {},
  error: {},
};

const openGraphSlice = createSlice({
  name: "openGraph",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOpenGraphData.pending, (state, action) => {
        // Use normalized URL to keep state consistent
        const normalizedUrl = normalizeUrlForCache(action.meta.arg);
        state.status[normalizedUrl] = "loading";
        state.error[normalizedUrl] = null;
      })
      .addCase(getOpenGraphData.fulfilled, (state, action) => {
        // action.payload.url is already normalized in the thunk
        const { url, data } = action.payload;
        state.data[url] = data;
        state.status[url] = "succeeded";
        state.error[url] = null;
      })
      .addCase(getOpenGraphData.rejected, (state, action) => {
        // Use normalized URL to keep state consistent
        const normalizedUrl = normalizeUrlForCache(action.meta.arg);
        const { message } = action.payload || { message: "Unknown error" };
        state.status[normalizedUrl] = "failed";
        state.error[normalizedUrl] = message;
      });
  },
});

export const {} = openGraphSlice.actions;
export const opengraphReducer = openGraphSlice.reducer;
